import {FC} from 'react'
import {useTranslation} from '@/translations/i18n'
import {ModalFooter, ModalTitle} from '@/components/ui/modal-atoms/ModalAtoms'
import {StyledModalHeader, StyledModalParagraph} from '@components/commons/delete-modal/style'
import {Button} from '@/components/ui/button/Button'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useDeleteConversationMessage} from '../../query/useDeleteConversationMessage'
import {StyledDeleteMessageModal, StyledDeleteMessageModalOverlay} from './style'

interface DeleteMessageModalProps {
    conversationId: string
    messageId: string
    onClose: () => void
}

export const DeleteMessageModal: FC<DeleteMessageModalProps> = ({conversationId, messageId, onClose}) => {
    const {t} = useTranslation()
    const deleteMessageMutation = useDeleteConversationMessage({
        onSuccess: onClose,
        // The backend also rejects deletions the UI can't anticipate (e.g. someone replied
        // meanwhile, making this no longer the last message) — close on the error toast too.
        onError: onClose
    })

    return (
        <>
            <StyledDeleteMessageModalOverlay
                onClick={event => {
                    event.stopPropagation()
                    onClose()
                }}
            />
            <StyledDeleteMessageModal width="400px" onClick={event => event.stopPropagation()}>
                <StyledModalHeader style={{border: 'none'}}>
                    <ModalTitle>{t('conversations:delete_message_title')}</ModalTitle>
                    <StyledModalParagraph>{t('conversations:delete_message_paragraph')}</StyledModalParagraph>
                </StyledModalHeader>
                <ModalFooter>
                    <Button variant="secondary" onClick={onClose}>
                        {t('commons:cancel')}
                    </Button>
                    <Button
                        variant="primaryDanger"
                        disabled={deleteMessageMutation.isPending}
                        onClick={() => deleteMessageMutation.mutate({conversationId, messageId})}
                    >
                        {t('commons:delete')}
                        {deleteMessageMutation.isPending && <Spinner />}
                    </Button>
                </ModalFooter>
            </StyledDeleteMessageModal>
        </>
    )
}
